<template>
  <div>
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">评价</div>
      <div class="nav-right">
        <img class="none" />
      </div>
    </div>
    <div class="block">
      <div class="ub ub-ver info-block">
        <div class="ub ub-pc" style="margin-bottom: 1em;">
          <div class="photo-block ub ub-ver ub-pc">
            <div class="infoma ub">
              <div class="photo-black">
                <img :src="order_dtl.photo2" class="photo" />
              </div>
            </div>
            <span class="nick2">{{order_dtl.nick2}}</span>
          </div>

          
            <div class="ub ub-ver ub-ac2">
              
                <span class="item">
                  <label class="l1">服务类型:&nbsp;</label>
                  <label class="l2">{{order_dtl.play_type}}</label>
                </span>

                <span class="item">
                  <label class="l1">服务时长:&nbsp;</label>
                  <label class="l2">{{order_dtl.play_time_ch}}</label>
                </span>

                <span class="item">
                  <label class="l1">订单状态:&nbsp;</label>
                  <label class="l2">{{order_dtl.order_state}}</label>
                </span>

                <span class="item">
                  <label class="l1">订单时间:&nbsp;</label>
                  <label class="l2">{{order_dtl.create_time}}</label>
                </span>
              
            </div>
        </div>


        <div class="ub ub-ac1">
        <div class="wechat ub ub-pc" @click="changeCheck('满意')">
          <div class="ub ub-pc">
            <div class="rad" v-if="com_rst != '满意'"></div>
            <div class="rad" v-if="com_rst == '满意'">
              <img class="rad_img" src="../../assets/img/radio.png" alt="" />
            </div>
          </div>
           <span style="font-size: 0.95em;margin-left:.5em;">满意</span>
        </div>

        <div class="ub ub-pc" @click="changeCheck('中等')">
          <div class="ub ub-pc">
            <div class="rad" v-if="com_rst != '中等'"></div>
            <div class="rad" v-if="com_rst == '中等'">
              <img class="rad_img" src="../../assets/img/radio.png" alt="" />
            </div>
          </div>
          <span style="font-size: 0.95em;margin-left:.5em;">中等</span>
        </div>

        <div class="ub ub-pc"  @click="changeCheck('差评')">
          <div class="ub ub-pc">
            <div class="rad" v-if="com_rst != '差评'"></div>
            <div class="rad" v-if="com_rst == '差评'">
              <img class="rad_img" src="../../assets/img/radio.png" alt="" />
            </div>
          </div>
          <span style="font-size: 0.95em;margin-left:.5em;">差评</span>
        </div>

    </div>

    <div class="ub ub-ver">
        <textarea contenteditable="true" v-model="com_dtl" placeholder="🖋请留下宝贵的评价" class="describe-text"></textarea>
    </div>

       <div class="ub ub-ac" style="padding: 0 .8em;">
      <div class="ub ub-ac ub-pc submit-btn" @click="save()">提交</div>
    </div>

      </div>
    </div>
  </div>
</template>

<script>
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      "play_order_id":"",
      "com_rst":"",
      "com_dtl":"",
      "order_dtl":{}
    };
  },
  mounted() {
    this.play_order_id=this.$route.params.play_order_id;
    this.init_page();
  },
  methods: {
    ...mapMutations(["get", "post"]), //引入方法
     back() {
      this.$router.go(-1); //返回上一层
    },
    changeCheck(check){
        this.com_rst=check;
    },
    init_page() {
      var self = this;
      this.$loading("加载中...");
      setTimeout(() => {
        self.$loading.close();
      }, 5000);
      self.get({
        url: "/App/Get_Order_Dtl/?id=" + this.play_order_id,
        success: function (data) {
          self.$loading.close();
          console.log(JSON.stringify(data));
          self.order_dtl=data;
        },
      });
    },
    save(){
      var data_send={
       "play_order_id":this.play_order_id,
       "com_rst":this.com_rst,
       "com_dtl":this.com_dtl
     };
     var strsend = JSON.stringify(data_send);
      var self = this;
      this.post({
        url: "/App/Save_Play_Comment",
        data: { "uid": "", "data": strsend },
        success: function (serve_data) {

            if(serve_data.state=="1"){
              self.$toast.center("评价成功~");
             
            }else 
            {
              self.$toast.center("评价失败~");
            }
        },
      });
    }
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  background-color: #f5f5f5;
  width: 100%;
  bottom: 0;
  top: 0;
}
.back-img {
  width: 100%;
}
.block {
  padding: 0.8em 0.5em;
}

.info-block {
  padding: 0.5em;
  background-color: #fff;
  border-radius: 0.5em;
  margin-bottom: 0.8em;
}

.photo-black {
  position: relative;
}
.photo-block {
  padding-right: 0.8em;
}
.photo-tag {
  position: absolute;
  background-color: #f3b4cf;
  font-size: 0.8em;
  border-radius: 1em;
  color: #fff;
  padding: 0.1em 0.2em;
  width: 3em;
  bottom: 0.4em;
  right: 1em;
  font-size: 0.6em;
}
.photo {
  width: 4em;
  height: 4em;
  border-radius: 50%;
  margin-right: 0.5em;
}
.nick2 {
  font-size: 0.9em;
}
.l1 {
  color: rgb(175, 174, 174);

}
.l2 {
  color: #333;
}
.time {
  margin: 0.5em 0;
}
.item {
  font-size: 0.85em;
  line-height: 1.7em;
}

.wechat-img {
  width: 1em;
  margin-right: 0.5em;
}

.rad {
  border: 2px solid #c9cacd;
  width: 1.1em;
  height: 1.1em;
  border-radius: 50%;
  background-color: #fff;
  /* padding: .2em; */
}

.rad_img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.describe-text {
  margin-top: 1em;
  height: 8em;
  
  outline: none;
  border-color: rgb(169, 215, 247);
  background-color: #fff;
  border-radius: 0.3em;
  padding: 0.8em;
  color: #333;
  font-size: 1em;
  resize: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.describe-text:focus {
  border-color: rgb(33, 164, 252);
}
.submit-btn {
  width: 100%;
  height: 2.3em;
  line-height: 2.3em;
  border-radius: 1.15em;
  background-color: #fc568c;
  margin-top: 1.5em;
  color: #fff0f4;
}
</style>